export default __webpack_public_path__ + "static/media/ico_city.abab772e.svg";